import CallStatus from "./CallStatus" ;
import InteractionType from "./InteractionType" ;
import Duration from "../core/Duration" ;
import DateTime from "../core/DateTime" ;
import Interaction from "../models/Interaction" ;
import DateFormat from "./DateFormat" ;


  export default  class  LeadUtils {  public static filterRanges: Array<string> = [ 'Today', 'Yesterday', 'Current Week', 'Current Month', 'Last Month', 'Last 3 Months', 'Last 6 Months', 'Last Year', 'This Year' ] ;
  public static leadStatuses: Array<string> = [ 'All', 'New', 'Attempted Contact', 'Contacted', 'Follow Up', 'Suspect', 'Prospect', 'Inprogress', 'Closed Won', 'Closed' ] ;
  public static colorPalette: Array<string> = [ 'FFFF5733', 'FF33FF57', 'FF5733FF', 'FFFF33A8', 'FF33FFF5', 'FFF5FF33', 'FFA833FF', 'FFFFC107', 'FFFF5722', 'FFFF9800', 'FF673AB7', 'FF3F51B5', 'FF00BCD4', 'FF009688', 'FF8BC34A', 'FFCDDC39', 'FF795548', 'FF9E9E9E', 'FF607D8B', 'FF000000' ] ;
 public constructor (  ) {
  }
  public static toGMTFromDateTime ( dateTime : DateTime,d3eParams ? : Partial<{format: string}> ) : string {
 let format=d3eParams?.format;

let dateFormat :DateFormat=new DateFormat(format);

return dateFormat.format(dateTime).toString() ; 
 }
  public static getToDateFilter ( filterByRange : string ) : DateTime {
 let now :DateTime=DateTime.now();

switch ( filterByRange ) {
 case 'Today' : {
 return new DateTime(now.year,now.month,now.day,23,59,59,999) ; 
 }

case 'Yesterday' : {
 let yesterday :DateTime=now.subtract(new Duration({ days:1 }));

return new DateTime(yesterday.year,yesterday.month,yesterday.day,23,59,59,999) ; 
 }

case 'Current Week' : {
 let daysToSunday :number=DateTime.sunday - now.weekday;

let endOfWeek :DateTime=now.add(new Duration({ days:daysToSunday }));

return new DateTime(endOfWeek.year,endOfWeek.month,endOfWeek.day,23,59,59,999) ; 
 }

case 'Current Month' : {
 let lastDayOfMonth :DateTime=new DateTime(now.year,now.month + 1,0);

return new DateTime(lastDayOfMonth.year,lastDayOfMonth.month,lastDayOfMonth.day,23,59,59,999) ; 
 }

case 'Last Month' : {
 let firstDayOfCurrentMonth :DateTime=new DateTime(now.year,now.month,1);

let lastDayOfLastMonth :DateTime=firstDayOfCurrentMonth.subtract(new Duration({ days:1 }));

return new DateTime(lastDayOfLastMonth.year,lastDayOfLastMonth.month,lastDayOfLastMonth.day,23,59,59,999) ; 
 }

case 'Last 3 Months' : {
 return new DateTime(now.year,now.month,now.day,23,59,59,999) ; 
 }

case 'Last 6 Months' : {
 return new DateTime(now.year,now.month,now.day,23,59,59,999) ; 
 }

case 'Last Year' : {
 return new DateTime(now.year - 1,12,31,23,59,59,999) ; 
 }

case 'This Year' : {
 return new DateTime(now.year,12,31,23,59,59,999) ; 
 }
 default: {
 return now ; 
 }
 }
 }
  public static getFromDateFilter ( filterByRange : string ) : DateTime {
 let now :DateTime=DateTime.now();

switch ( filterByRange ) {
 case 'Today' : {
 return new DateTime(now.year,now.month,now.day,0,0,0,0) ; 
 }

case 'Yesterday' : {
 let yesterday :DateTime=now.subtract(new Duration({ days:1 }));

return new DateTime(yesterday.year,yesterday.month,yesterday.day,0,0,0,0) ; 
 }

case 'Current Week' : {
 let daysToSubtract :number=now.weekday - 1;

//  Assuming week starts on Monday

let startOfWeek :DateTime=now.subtract(new Duration({ days:daysToSubtract }));

return new DateTime(startOfWeek.year,startOfWeek.month,startOfWeek.day,0,0,0,0) ; 
 }

case 'Current Month' : {
 return new DateTime(now.year,now.month,1,0,0,0,0) ; 
 }

case 'Last Month' : {
 let firstDayOfCurrentMonth :DateTime=new DateTime(now.year,now.month,1);

let firstDayOfLastMonth :DateTime=new DateTime(firstDayOfCurrentMonth.year,firstDayOfCurrentMonth.month - 1,1);

return firstDayOfLastMonth ; 
 }

case 'Last 3 Months' : {
 let threeMonthsAgo :DateTime=new DateTime(now.year,now.month - 3,1);

return threeMonthsAgo ; 
 }

case 'Last 6 Months' : {
 let sixMonthsAgo :DateTime=new DateTime(now.year,now.month - 6,1);

return sixMonthsAgo ; 
 }

case 'Last Year' : {
 return new DateTime(now.year - 1,1,1,0,0,0,0) ; 
 }

case 'This Year' : {
 return new DateTime(now.year,1,1,0,0,0,0) ; 
 }
 default: {
 return now ; 
 }
 }
 }
  public static getMobileCodeWithCountry (  ) : Array<string> {
 return [ '+1 United States - US', '+44 United Kingdom - GB', '+1 Canada - CA', '+61 Australia - AU', '+49 Germany - DE', '+91 India - IN', '+33 France - FR', '+52 Mexico - MX', '+55 Brazil - BR', '+81 Japan - JP', '+39 Italy - IT', '+34 Spain - ES', '+31 Netherlands - NL', '+41 Switzerland - CH', '+82 SouthKorea - KR', '+47 Norway - NO', '+46 Sweden', '+48 Poland - PL', '+351 Portugal - PT', '+43 Austria - AT' ] ; 
 }
  public static formatDateTime ( sentDateTime : DateTime,receivedDateTime : DateTime ) : string {
 let effectiveDateTime :DateTime=sentDateTime !== null ? sentDateTime : receivedDateTime;

if ( effectiveDateTime === null ) {
 return '' ; 
 }

let now :DateTime=DateTime.now();

//  Calculate start of the week (Monday at 00:00)

let startOfWeek :DateTime=now.subtract(new Duration({ days:now.weekday - 1 }));

startOfWeek=new DateTime(startOfWeek.year,startOfWeek.month,startOfWeek.day);

//  If the date is today, show the time

if ( effectiveDateTime.day === now.day && effectiveDateTime.month === now.month && effectiveDateTime.year === now.year ) {
 return new DateFormat('HH:mm').format(effectiveDateTime) ; 
 }

if ( effectiveDateTime.isAfter(startOfWeek) ) {
 return new DateFormat('EEE, HH:mm').format(effectiveDateTime) ; 
 }

return new DateFormat('EEE, dd MMM').format(effectiveDateTime) ; 
 }
  public static getColorForFirstLetter ( name : string ) : string {
 if ( name === null || name.isEmpty ) {
 return 'ff000000' ; 
 }

//  Get the first letter of the name

let firstLetter :string=name.substring(0,1).toUpperCase();

//  Calculate index based on the ASCII value of the first letter

let index :number=firstLetter.codeUnitAt(0) % LeadUtils.colorPalette.length;

return LeadUtils.colorPalette [ index ] ; 
 }
  public static getInteractionsByType ( interactions : Array<Interaction>,filterType : string ) : Array<Interaction> {
 let itrs :Array<Interaction>=[  ];

if ( filterType === 'All' ) {
 return interactions ; 
 }
 else if ( filterType === 'Missed' ) {
 return interactions.where(( i ) => (i.isIncoming && i.callStatus === CallStatus.Unanswered)).toList() ; 
 }
 else if ( filterType === 'Incoming' ) {
 return interactions.where(( i ) => i.isIncoming).toList() ; 
 }
 else if ( filterType === 'Outgoing' ) {
 return interactions.where(( i ) => !i.isIncoming).toList() ; 
 }
 else if ( filterType === 'Voicemail' ) {
 return interactions.where(( i ) => i.type === InteractionType.Voicemail).toList() ; 
 }
 else {
 return itrs ; 
 }
 }
 }